import React from 'react';
import PlanPicker from './PlanPicker';
import { PlanPickerConfirmation } from './PlanPickerConfirmation';
import { PlanPickerSuccess } from './PlanPickerSuccess';
import { ILiliPlan } from '../types';
import { LiliPlanType } from '../constants';

import { GenericErrorModal } from '../../../components/errors/GenericErrorModal';

export enum PlanPickerState {
    Picker = 0,
    Confirmation = 1,
    Success = 2,
    Error = 3

}

interface IProps {
    activeComponent: PlanPickerState;
    currentPlan: string;
    availablePlans: ILiliPlan[]
    onCloseClick: () => void
    onGreatClick: () => void
    onUpgradeClick: (plan: ILiliPlan, isAnnual: boolean) => void
    onTermsConfirmed: () => void
    onErrorActionClicked: () => void
    selectedPlan: ILiliPlan | null
    origin: string
    promotionType?: string
    errorToShow?: string
}

export const UserMessageContentSwitch = ({
  activeComponent,
  selectedPlan,
  onCloseClick,
  onUpgradeClick,
  onTermsConfirmed,
  currentPlan,
  availablePlans,
  onGreatClick,
  origin,
  promotionType,
  onErrorActionClicked,
  errorToShow,
}: IProps) => {
  switch (activeComponent) {
    case PlanPickerState.Picker:

      return (
        <PlanPicker
          onCloseClick={() => {
            onCloseClick();
          }}
          onUpgradeClick={(plan, isAnnual) => {
            onUpgradeClick(plan, isAnnual);
          }}
          currentPlan={currentPlan}
          availablePlans={availablePlans}
          origin={origin}
          planTypeToShow={LiliPlanType.SMART}
          promotionType={promotionType}
        />
      );
    case PlanPickerState.Confirmation:

      return (
        <PlanPickerConfirmation
          onTermsConfirmed={() => {
            onTermsConfirmed();
          }}
          currentPlan={currentPlan}
        />
      );
    case PlanPickerState.Success:
      return (selectedPlan && (
      <PlanPickerSuccess
        newPlan={selectedPlan}
        currentPlanType={currentPlan}
        onGreatClick={() => {
          onGreatClick();
        }}
      />
      ));
    case PlanPickerState.Error:
      return (errorToShow
        ? (
          <GenericErrorModal
            title='Something went wrong'
            description={errorToShow}
            buttonTitle='Got It'
            onActionClick={() => {
              onErrorActionClicked();
            }}
          />
        ) : <div />);
    default:
      return (<div />);
  }
};
